module.exports = __webpack_public_path__ + "img/09-01_Keeping An Open Mind.dfaab614.svg";